import {Component, Inject} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';

import {ErrorResponse} from '../../../../data/model/errorResponse';
import {OrganisationsDataManager} from '../../../../data/organisations.datamanager';
import {UploadDataManager} from '../../../../data/upload.datamanager';

@Component({
  selector: 'advanced-filtering-by-file-users-dialog',
  templateUrl: './advanced-filtering-by-file-users-dialog.html'
})
export class AdvancedFilteringByFileUsersDialogComponent {
  xlsx: File = null;

  constructor(
      private uploadDataManager: UploadDataManager,
      private organisationsDataManager: OrganisationsDataManager,
      public dialogRef: MatDialogRef<AdvancedFilteringByFileUsersDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  handleFileInput(files: FileList) {
    this.xlsx = files.item(0);
  }

  onAddClick() {
      const filereader: FileReader = new FileReader();
      filereader.readAsDataURL(this.xlsx);
      filereader.onload = (e) => {
        const url = filereader.result;
        const base64Data =
            url.substr(url.indexOf('base64,') + 'base64,'.length);

        this.uploadDataManager
            .uploadUsersFilterToApi(base64Data)
            .subscribe(
                (response) => {
                  this.closeDialogSuccess(response);
                },
                (err) => {
                  this.closeDialogWithError(err.json());
                });
      };
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  openFileUpload() {
    document.getElementById('file-id').click();
  }

  closeDialogWithError(error: ErrorResponse) {
    this.dialogRef.close(error);
  }

  closeDialogSuccess(response: any) {
    this.dialogRef.close(response);
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/users/advanced.filtering/advanced.filtering.by.file.users.dialog.component.ts